module.exports = __webpack_public_path__ + "img/indoorArmingCameraAlinoDetect.a877bdd0.webp";